import React from "react";

const overrides = {
  MuiFormControlLabel: {
    root: { marginLeft: 0 },
  },
  MuiButton: { containedSecondary: { color: "#ffffff" } },
  MuiChip: {
    labelSmall: { fontSize: "0.8rem", paddingLeft: "6px", paddingRight: "6px" },
  },
  MuiTooltip: { tooltip: { fontSize: "0.8rem" } },
};

const damageTypes = {
  BREAK: "#E7FF00", //neon yellow
  CRACK: "#5FE8FF", //neon purple
  DENT: "#FC49AB", //neon pink
  GLASS: "#A95AEC", //neon blue
  MISSING: "#FF7300", //neon orange
  SCRATCH: "#64FF00", //neon green
  default: "#1188FF",
};

const breakpoints = {
  values: {
    xs: 0,
    sm: 660,
    md: 1024,
    lg: 1280,
    xl: 1920,
  },
};

const GOLDENRATIO = (1 + Math.sqrt(5)) / 2;
const goldenRatio = (diff: number) => Math.round(GOLDENRATIO ** diff * 1000) / 1000;

export const one = {
  palette: {
    primary: { main: "#ffffff" },
    secondary: { main: "#68388b" },
  },
  damageTypes,
  breakpoints,
  overrides,
  goldenRatio,
  // themeName: "Texas Rose Millbrook Rhinoceros",
};

export const two = {
  palette: {
    primary: { main: "#4E342E" },
    secondary: { main: "#F57F17" },
  },
  damageTypes,
  breakpoints,
  overrides,
  goldenRatio,
  // themeName = "Kabul Ecstasy Crow",
};

export const three = {
  palette: {
    primary: { main: "#455A64" },
    secondary: { main: "#FDD835" },
  },
  damageTypes,
  breakpoints,
  overrides,
  goldenRatio,
  // themeName: "Fiord Dark Sun Aldabra Tortoise",
};

export const four = {
  palette: {
    primary: { main: "#3E2723" },
    secondary: { main: "#F9A825" },
  },
  damageTypes,
  breakpoints,
  overrides,
  goldenRatio,
  // themeName: "English Walnut Sea Buckthorn Malayan Tapir",
};

declare module "@material-ui/core/styles/createMuiTheme" {
  interface Theme {
    damageTypes: {
      BREAK: React.CSSProperties["color"];
      CRACK: React.CSSProperties["color"];
      DENT: React.CSSProperties["color"];
      GLASS: React.CSSProperties["color"];
      MISSING: React.CSSProperties["color"];
      SCRATCH: React.CSSProperties["color"];
      default: React.CSSProperties["color"];
    };
    goldenRatio: (diff: number) => number;
  }

  // allow configuration using `createMuiTheme`
  interface ThemeOptions {
    damageTypes: {
      BREAK: React.CSSProperties["color"];
      CRACK: React.CSSProperties["color"];
      DENT: React.CSSProperties["color"];
      GLASS: React.CSSProperties["color"];
      MISSING: React.CSSProperties["color"];
      SCRATCH: React.CSSProperties["color"];
      default: React.CSSProperties["color"];
    };
    goldenRatio?: (diff: number) => number;
  }
}
